export default __webpack_public_path__ + "static/media/icon-ask-us.5b41fa44.svg";